//background: #FFC2D1;
//background: #EEEEEE

/*
timetable
black: #333F48

active grdiant E0004D ~ EA27C2
*/
import clsx from "clsx";
import React from "react";

type Props = {
  active?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
};

export default function Badge({ active, onClick, children }: Props) {
  return (
    <div
      className={clsx([
        "border rounded-md py-1 pl-1.5 pr-2 cursor-pointer gap-2 text-xs break-words font-normal leading-4 text-brand-neutral-80",
        {
          "bg-[#FFC2D1]": active,
          "bg-[#EEEEEE]": !active,
        },
      ])}
      onClick={() => onClick?.()}
    >
      {children}
    </div>
  );
}
